export const locale = {
    lang: 'ar',
    data: {
        PROJECTS_BOARD_NEW_DIALOG_CREATE_BOARD: 'إنشاء لوحة',
        PROJECTS_BOARD_NEW_DIALOG_GENERAL: 'عموميات',
        PROJECTS_BOARD_NEW_DIALOG_MEMBERS: 'الأعضاء',
    }
};
